<template>
  <div class="row">
    <div :class="`col-${customCols.leftCol} d-flex align-items-center`">
      <p class="h1 m-0">{{ title }}</p>
    </div>
    <div :class="`col-${customCols.rightCol}`">
      <div class="d-flex float-end align-items-center">
        <a style="margin-right: 25px;" v-if="showSettingBtn" href="#" @click="$emit('onClickSettingButton')" class="mr">Setting</a>
        <slot name="title-details"></slot>
        <button
            style="min-width: 64px;margin-right: 25px;"
            v-if="showAddNew"
            @click="$emit('onClickAddNewButton')"
            class="btn btn-primary waves-effect waves-float waves-light"
        >{{ btnTitle }}
        </button>

        <button
            style="min-width: 64px;margin-right: 25px;"
            v-if="showExtraBtn"
            @click="$emit('onClickExtraBtn')"
            class="btn btn-primary waves-effect waves-float waves-light"
        >
          {{ extraBtnTitle }}
        </button>

        <slot name="extra-btn"></slot>

        <button
          v-if="showFilterBtn"
          class="btn btn-sm font-medium-3"
          @click="$emit('onClickFilterButton')"
        >
          <i class="fa-solid fa-gear"></i>
        </button>

        <button
            v-if="showBtn"
            @click="$emit('onClickCloseButton')"
            class="btn btn-close"
        >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleButton',
  props: {
    title: String,
    btnTitle: String,
    extraBtnTitle: String,
    showBtn: {
      default: true
    },
    showAddNew: {
      default: false
    },
    showExtraBtn: {
      default: false
    },
    showSettingBtn: {
      default: false
    },
    showFilterBtn: {
      default: false
    },
    customCols: {
      type: Object || null,
      default: {
        leftCol: 8,
        rightCol: 4
      }
    }
  }
}
</script>

<style scoped>
.cancel-btn {
  background-color: #F0F2F5;
  color: #7D7D7D;
}

.mr {
  margin-right: 1rem;
}

.cancel-btn:hover {
  background-color: #e9edf5;
}

hr {
  margin: 0 -3%;
  width: 106%;
}

@media screen and (min-width: 1200px) {
  .btn-close {
    /* margin-left: 200px; */
    /* font-size: 32px; */
    /* margin-top: 5px; */
    width: 30px;
    height: 30px;
    background-color: #E4E6EB;
    border-radius: 50%;
    /* margin-right: 30px; */
  }

  .btn-close:hover {
    width: 30px;
    height: 30px;
    background-color: #D8DADF;
    border-radius: 50%;
  }
}

@media screen and (max-width: 720px) {
  .btn-close {
    width: 25px;
    height: 25px;
    background-color: #E4E6EB;
    border-radius: 50%;
    margin-top: -5px;
    margin-right: -5px;
  }
}
</style>
